import { defineStore } from 'pinia'

export const promoBarStore = defineStore('promobar', {
	state: () => ({
		options: {
			cta: 0
		}
	}),
	actions: {

	}
	// getters
	// actions
})